/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { push } from 'connected-react-router';
import { Text, Pane, Flex, Button } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { GroupDelegate, Relationship } from '@leverege/molten/imagine';
import qs from 'query-string';
import { GroupUtil } from '@leverege/molten/screens';
import { FilterSourcesModel, FilterSourceModel } from '@leverege/molten/filters';
import { connect } from 'react-redux';
import { getCompanyId, buildFoundLocatorsFilter, buildLostLocatorsFilter, buildRecovrSalesFilter, buildRecovrRefundsFilter } from './Util';
import { getCurrentMonthlyBilling } from '../../../util/Interface';
import { formatCurrency, formatPercent } from '../../../util/Formatting';
import S from './Billing.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  encodeQuery
} = GroupUtil;
function BillingBreakdownCard(props) {
  const [companyContract, setCompanyContract] = useState({});
  const [billingReport, setBillingReport] = useState({});
  const [invoiceIds, setInvoiceIds] = useState([]);
  const {
    parentItem,
    sharedProps,
    chargesAggs,
    creditsAggs
  } = props;
  const isRootBill = sharedProps?.relationship?.path === 'bill';
  const systemId = parentItem?.data?.systemId;
  const locationId = sharedProps?.match?.params?.locationId || (parentItem?.type === 'location' ? parentItem.id : '');
  const relationship = Relationship.getByPath('company.companyContracts');
  let type;
  if (sharedProps?.item) {
    type = 'location';
  }
  if (parentItem) {
    type = parentItem?.type;
  }
  const serviceFee = billingReport.data?.serviceFee;
  const lostLocatorPrice = companyContract?.data?.lostLocatorPrice;
  const recovrSalePrice = companyContract?.data?.recovrSalePrice;
  const numLocationsRateUnmet = billingReport.data?.numLocationsRateUnmet || 0;
  const sellThroughRateMet = type === 'company' ? numLocationsRateUnmet === 0 : serviceFee === 0;
  const sellThroughRateVariant = sellThroughRateMet ? 'sellThroughRateMet' : 'sellThroughRateFailed';
  const companySellThroughRateDescription = sellThroughRateMet ? 'All Locations Met Target' : `${numLocationsRateUnmet} Location${numLocationsRateUnmet === 1 ? '' : 's'} Missed Target`;
  const percentageFormat = type === 'company' ? '' : formatPercent(billingReport.data?.sellThroughRate);
  const sellThroughRateDescription = type === 'company' ? companySellThroughRateDescription : 'Sell-Through Rate';
  let groupActions, companyId;
  const getAddendumInfo = () => {
    const {
      addendumChargesActions,
      addendumCreditsActions
    } = props;
    Promise.all([GlobalState.dispatch(addendumChargesActions.search({
      limit: 0,
      aggs: {
        charges: {
          type: 'stats',
          field: 'data/amount'
        }
      },
      filter: {
        field: 'data/type',
        type: 'equals',
        value: 'charge'
      }
    }, {
      ttl: 30000
    })), GlobalState.dispatch(addendumCreditsActions.search({
      limit: 0,
      aggs: {
        credits: {
          type: 'stats',
          field: 'data/amount'
        }
      },
      filter: {
        field: 'data/type',
        type: 'equals',
        value: 'credit'
      }
    }, {
      ttl: 30000
    }))]);
  };
  useEffect(() => {
    const execute = async () => {
      // card is on detail drilldown
      if (sharedProps?.item) {
        companyId = sharedProps?.parentItem?.data?.data?.company?.id || sharedProps.match?.params?.companyId;
        if (!companyId) {
          companyId = await getCompanyId(locationId);
        }
        const companyContractId = sharedProps.parentItem?.data?.data?.companyContractId;
        const match = {
          ...sharedProps.actions.match,
          params: {
            companyId
          }
        };
        groupActions = new GroupDelegate({
          relationship: relationship.createResolved(match),
          match,
          ttl: 30000
        });
        const contractActions = groupActions.item(companyContractId).get();
        GlobalState.dispatch(contractActions).then(res => {
          setCompanyContract(res);
        });
        setBillingReport(sharedProps?.parentItem?.data);
        getAddendumInfo();

        // card is in billing viewer
      } else {
        companyId = parentItem?.type === 'company' ? parentItem.id : parentItem?.data?.data?.company?.id;
        getCurrentMonthlyBilling(systemId, companyId, locationId).then(res => {
          setBillingReport(res);
          setCompanyContract(res.data.activeCompanyContract);
        });
      }
    };
    execute();
  }, [systemId, companyId]);
  const onLinkClick = ({
    data
  }) => {
    const {
      childPath,
      filter,
      filterName
    } = data;
    const {
      sharedProps
    } = props;

    // Create resolved relationship object.
    const relationship = Relationship.getByPath(sharedProps?.relationship?.path.replace('bills', childPath));
    const resolvedRelationship = relationship.createResolved(sharedProps?.match);

    // Create delegate object.
    const delegate = new GroupDelegate({
      match: sharedProps?.match,
      relationship: resolvedRelationship
    });

    // Create FilterSourcesModel object.
    let nFilters = FilterSourcesModel.create();
    let nFilter = FilterSourceModel.create();
    nFilter = FilterSourceModel.setFilter(nFilter, filter);
    nFilters = FilterSourcesModel.setSource(nFilters, filterName, nFilter);

    // Create search string with the encoded filters.
    const search = encodeQuery({
      filters: nFilters
    });

    // Push to the path of the delegate + filter. Delegate doesn't use local filter in the goTo method.
    // Filters won't be displayed in the UI given that we're not using the 'filterBar' filter source.
    const path = delegate.getUrl();
    GlobalState.dispatch(push(`${path}?${search}`));
  };
  const onAddendumLinkClick = ({
    data
  }) => {
    const {
      path,
      filters,
      ...rest
    } = data;
    const {
      history,
      location,
      sharedProps
    } = props;
    const pathname = location?.pathname || sharedProps?.location?.pathname;
    let newPath = pathname.split('info')[0];
    newPath = `${newPath}addendum`;
    newPath += `?${qs.stringify({
      ...filters,
      ...rest
    }, {
      arrayFormat: 'comma'
    })}`;
    const historyObj = history || sharedProps.history;
    historyObj.push(newPath);
  };
  const recovrSales = billingReport.data?.sales?.recovrSales || 0;
  const priorVoidedSales = billingReport.data?.sales?.priorVoidedSales || 0;
  const numLost = billingReport.data?.locator?.numLost || 0;
  const numFound = billingReport.data?.locator?.numFound || 0;
  const addendumChargeAmount = chargesAggs?.charges?.sum || 0;
  const addendumCreditAmount = creditsAggs?.credits?.sum || 0;
  const numAddendumCharges = chargesAggs?.charges?.count || 0;
  const numAddendumCredits = creditsAggs?.credits?.count || 0;
  useEffect(() => {
    // If billing report is a device.
    if (billingReport?.networkAliases?.['recovr-invoice']?.invoiceId) {
      const invoiceIds = [billingReport.networkAliases['recovr-invoice'].invoiceId];
      setInvoiceIds(invoiceIds);
      return;
    }

    // If billing report is cached data from the current month.
    if (billingReport?.data?.invoiceIds) {
      const invoiceIds = billingReport.data.invoiceIds;
      setInvoiceIds(invoiceIds);
    }
  }, [billingReport]);
  return /*#__PURE__*/_jsx(Pane, {
    variant: "billingCard",
    className: S.billingBreakdownCard,
    children: /*#__PURE__*/_jsxs(Pane, {
      variant: "billingCardContent",
      children: [/*#__PURE__*/_jsx(Pane, {
        variant: "billingCardBody",
        className: S.billingCardPane,
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "billingCardBody",
          className: S.body,
          children: [/*#__PURE__*/_jsxs(Flex, {
            variant: "colM",
            className: S.cardBody,
            children: [/*#__PURE__*/_jsxs(Flex, {
              variant: "colM",
              className: S.mobileheader,
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "billingCardBodyColor2",
                children: " Service Fee"
              }), /*#__PURE__*/_jsx(Text, {
                variant: "bold",
                className: S.billingValue,
                children: formatCurrency(serviceFee)
              })]
            }), /*#__PURE__*/_jsx(Text, {
              variant: sellThroughRateVariant,
              children: /*#__PURE__*/_jsxs(Flex, {
                variant: "rowM",
                children: [/*#__PURE__*/_jsx(Text, {
                  variant: "sellThroughRateDescription",
                  className: S.percentageDetail,
                  children: percentageFormat
                }), /*#__PURE__*/_jsx(Text, {
                  className: S.percentageDetail,
                  variant: "bodySmall",
                  children: sellThroughRateDescription
                })]
              })
            })]
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colM",
            className: S.cardBody,
            children: [/*#__PURE__*/_jsxs(Flex, {
              variant: "colM",
              className: S.mobileheader,
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "billingCardBodyColor4",
                children: "Charges"
              }), /*#__PURE__*/_jsx(Text, {
                variant: "bold",
                className: S.billingValue,
                children: formatCurrency((recovrSalePrice * recovrSales || 0) + (lostLocatorPrice * numLost || 0) + addendumChargeAmount)
              })]
            }), /*#__PURE__*/_jsxs(Flex, {
              wrap: "wrap",
              variant: "rowMCenter",
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "bodyBold",
                children: formatCurrency(recovrSalePrice * recovrSales || 0)
              }), /*#__PURE__*/_jsxs(Text, {
                variant: "caption",
                children: ["= ", formatCurrency(recovrSalePrice || 0), " \xD7"]
              }), isRootBill ? /*#__PURE__*/_jsxs(Text, {
                variant: "caption",
                children: [recovrSales, " RecovR Sale", recovrSales === 1 ? '' : 's']
              }) : /*#__PURE__*/_jsxs(Button, {
                disabled: !recovrSales,
                className: S.billingLink,
                variant: "linkLeftMargin",
                eventData: {
                  childPath: 'sales',
                  filterName: 'recovrSales',
                  filter: buildRecovrSalesFilter(invoiceIds)
                },
                onClick: onLinkClick,
                children: [recovrSales, " RecovR Sale", recovrSales === 1 ? '' : 's']
              })]
            }), /*#__PURE__*/_jsxs(Flex, {
              wrap: "wrap",
              variant: "rowMCenter",
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "bodyBold",
                children: formatCurrency(lostLocatorPrice * numLost || 0)
              }), /*#__PURE__*/_jsxs(Text, {
                variant: "caption",
                children: ["= ", formatCurrency(lostLocatorPrice || 0), " \xD7"]
              }), isRootBill ? /*#__PURE__*/_jsxs(Text, {
                variant: "caption",
                children: [numLost, " Lost Locator", numLost === 1 ? '' : 's']
              }) : /*#__PURE__*/_jsxs(Button, {
                disabled: !numLost,
                className: S.billingLink,
                variant: "linkLeftMargin",
                eventData: {
                  childPath: 'lost',
                  filterName: 'lostLocators',
                  filter: buildLostLocatorsFilter(invoiceIds)
                },
                onClick: onLinkClick,
                children: [numLost, " Lost Locator", numLost === 1 ? '' : 's']
              })]
            }), sharedProps ? /*#__PURE__*/_jsxs(Flex, {
              wrap: "wrap",
              variant: "rowMCenter",
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "bodyBold",
                children: formatCurrency(addendumChargeAmount)
              }), /*#__PURE__*/_jsx(Text, {
                variant: "caption",
                children: "= "
              }), isRootBill ? /*#__PURE__*/_jsxs(Text, {
                variant: "caption",
                children: [numAddendumCharges, " Charge Addend", numAddendumCharges === 1 ? 'um' : 'a']
              }) : /*#__PURE__*/_jsxs(Button, {
                disabled: !numAddendumCharges,
                className: S.billingLink,
                variant: "linkLeftMargin",
                eventData: {
                  path: 'sales',
                  filters: {
                    type: 'charge'
                  }
                },
                onClick: onAddendumLinkClick,
                children: [numAddendumCharges, " Charge Addend", numAddendumCharges === 1 ? 'um' : 'a']
              })]
            }) : '']
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "colM",
            className: S.cardBody,
            children: [/*#__PURE__*/_jsxs(Flex, {
              variant: "colM",
              className: S.mobileheader,
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "billingCardBodyColor1",
                children: "Credits"
              }), /*#__PURE__*/_jsx(Text, {
                variant: "bold",
                className: S.billingValue,
                children: formatCurrency((recovrSalePrice * priorVoidedSales || 0) + (lostLocatorPrice * numFound || 0) + addendumCreditAmount)
              })]
            }), /*#__PURE__*/_jsxs(Flex, {
              wrap: "wrap",
              variant: "rowMCenter",
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "bodyBold",
                children: formatCurrency(recovrSalePrice * priorVoidedSales || 0)
              }), /*#__PURE__*/_jsxs(Text, {
                variant: "caption",
                children: ["= ", formatCurrency(recovrSalePrice || 0), " \xD7"]
              }), isRootBill ? /*#__PURE__*/_jsxs(Text, {
                variant: "caption",
                children: [priorVoidedSales, " RecovR Sale Refund", priorVoidedSales === 1 ? '' : 's']
              }) : /*#__PURE__*/_jsxs(Button, {
                disabled: !priorVoidedSales,
                className: S.billingLink,
                variant: "linkLeftMargin",
                eventData: {
                  childPath: 'sales',
                  filterName: 'recovrRefunds',
                  filter: buildRecovrRefundsFilter(invoiceIds)
                },
                onClick: onLinkClick,
                children: [priorVoidedSales, " RecovR Sale Refund", priorVoidedSales === 1 ? '' : 's']
              })]
            }), /*#__PURE__*/_jsxs(Flex, {
              wrap: "wrap",
              variant: "rowMCenter",
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "bodyBold",
                children: formatCurrency(lostLocatorPrice * numFound || 0)
              }), /*#__PURE__*/_jsxs(Text, {
                variant: "caption",
                children: ["= ", formatCurrency(lostLocatorPrice || 0), " \xD7"]
              }), isRootBill ? /*#__PURE__*/_jsxs(Text, {
                variant: "caption",
                children: [numFound, " Found Locator", numFound === 1 ? '' : 's']
              }) : /*#__PURE__*/_jsxs(Button, {
                disabled: !numFound,
                className: S.billingLink,
                variant: "linkLeftMargin",
                eventData: {
                  childPath: 'lost',
                  filterName: 'foundLocators',
                  filter: buildFoundLocatorsFilter(invoiceIds)
                },
                onClick: onLinkClick,
                children: [numFound, " Found Locator", numFound === 1 ? '' : 's']
              })]
            }), sharedProps ? /*#__PURE__*/_jsxs(Flex, {
              wrap: "wrap",
              variant: "rowMCenter",
              children: [/*#__PURE__*/_jsxs(Text, {
                variant: "bodyBold",
                children: [" ", formatCurrency(addendumCreditAmount)]
              }), /*#__PURE__*/_jsx(Text, {
                variant: "caption",
                children: "= "
              }), isRootBill ? /*#__PURE__*/_jsxs(Text, {
                variant: "caption",
                children: [numAddendumCredits, " Credit Addend", numAddendumCredits === 1 ? 'um' : 'a']
              }) : /*#__PURE__*/_jsxs(Button, {
                disabled: !numAddendumCredits,
                className: S.billingLink,
                variant: "linkLeftMargin",
                eventData: {
                  path: 'sales',
                  filters: {
                    type: 'credit'
                  }
                },
                onClick: onAddendumLinkClick,
                children: [numAddendumCredits, " Credit Addend", numAddendumCredits === 1 ? 'um' : 'a']
              })]
            }) : '']
          })]
        })
      }), /*#__PURE__*/_jsx(Text, {
        variant: "billingCardLink",
        children: /*#__PURE__*/_jsx("a", {
          href: "https://help.recovr.biz/en/articles/5075523-guide-to-the-billing-dashboard",
          rel: "noreferrer",
          target: "_blank",
          children: "What do these numbers mean?"
        })
      })]
    })
  });
}
export default connect((state, ownProps) => {
  const {
    sharedProps
  } = ownProps;
  const actions = sharedProps?.actions;
  if (!sharedProps?.item) {
    return {
      ...sharedProps
    };
  }
  const childActions = actions.child('addendum');
  const addendumChargesActions = new GroupDelegate({
    match: childActions.match,
    relationship: childActions.relationship.createResolved(childActions.match),
    queryName: 'totalAddendumChargesAgg'
  });
  const addendumCreditsActions = new GroupDelegate({
    match: childActions.match,
    relationship: childActions.relationship.createResolved(childActions.match),
    queryName: 'totalAddendumCreditsAgg'
  });
  const chargesAggs = addendumChargesActions.getList(state, {
    getAll: true
  })?.aggs;
  const creditsAggs = addendumCreditsActions.getList(state, {
    getAll: true
  })?.aggs;
  return {
    props: ownProps,
    models: state.models,
    addendumChargesActions,
    addendumCreditsActions,
    chargesAggs,
    creditsAggs
  };
})(BillingBreakdownCard);